// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".booking-paid__image[data-v-7290f9b0]{text-align:center}.booking-paid__image img[data-v-7290f9b0]{width:50%}.booking-paid__title[data-v-7290f9b0]{margin-top:-10px;text-align:justify;font-style:normal;font-weight:400;font-size:20px;line-height:24px}.booking-paid__details[data-v-7290f9b0]{margin-top:28px}", ""]);
// Exports
module.exports = exports;
